import { Calendar } from "fullcalendar";
import dayGridPlugin from "@fullcalendar/daygrid";
import ruLocale from "@fullcalendar/core/locales/ru";

function formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Месяцы с 0
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
}

function getDateValue(item) {
    return typeof item === "string" ? item : item?.date;
}

function getServiceTypeRef(item) {
    return typeof item === "string" ? undefined : item?.serviceTypeRef;
}

/**
 *
 * @param {{
 *      calendarEl: HTMLElement,
 *      freeDates: string[],
 *      hasWaitingList?: boolean,
 *      highlitedDates?: {date: string, serviceTypeRef?: string}[],
 *      waitingListDates?: {date: string, serviceTypeRef?: string}[],
 *      forceDisableNonHighlightedDates?: boolean,
 *      onDateClick?: (date?: string, isWaitingList:boolean) => boolean
 * }} param0
 */
export function initCalendar({
    calendarEl,
    freeDates,
    hasWaitingList = false,
    highlitedDates = [],
    waitingListDates = [],
    shouldHighlightRedirect = true,
    commonServiceTypeRef = undefined,
    forceDisableNonHighlightedDates = false,
    onDateClick = () => true,
}) {

    const dateKeeper = document.querySelector(`#${calendarEl.getAttribute("data-for")}`);


    console.log(freeDates, 'freeDates');
    console.log(hasWaitingList, 'hasWaitingList');
    console.log(highlitedDates, 'highlitedDates');

    const waitingListDateSet = new Set(
        waitingListDates
            .map((item) => (typeof item === "string" ? item : item?.date))
            .filter(Boolean),
    );

    const today = new Date();
    today.setHours(0, 0, 0, 0);


    const maxDays = 62;

    const maxDate = new Date();
    maxDate.setDate(today.getDate() + maxDays);

    const calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        locale: ruLocale,
        headerToolbar: {
            start: "prev", // will normally be on the left. if RTL, will be on the right
            center: "title",
            end: "next",
        },
        titleFormat: {
            year: "numeric",
            month: "long",
        },
        datesSet: (info) => {
            const titleElement = calendarEl.querySelector(".fc-toolbar-title");
            const title = info.view.title.replace(" г.", ""); // Удаляем "г."
            titleElement.textContent = title; // Обновляем содержимое заголовка

            document.querySelectorAll(".fc-daygrid-day").forEach((el) => {
                el.classList.remove(
                    "fc-day-highlited",
                    "fc-day-disabled",
                    "fc-day-waiting-list",
                    "fc-day-redirect",
                );

                const date = new Date(el.dataset.date);
                const dateStr = formatDateToString(date);
                const isInFreeDates = freeDates.includes(dateStr);
                const isWaitingListDate = waitingListDateSet.has(dateStr);
                const isWaitingListOnly = isWaitingListDate && hasWaitingList && !isInFreeDates;

                const isHighlited = !!highlitedDates
                    .find((rd) => getDateValue(rd) === dateStr && !getServiceTypeRef(rd));

                const shouldRedirectTo = highlitedDates
                    .find((rd) => getDateValue(rd) === dateStr && getServiceTypeRef(rd));
                const isRedirectDate = !!shouldRedirectTo;

                if (commonServiceTypeRef) {
                    el.dataset.serviceTypeRef = commonServiceTypeRef;
                }

                if (shouldRedirectTo) {
                    if (shouldHighlightRedirect) {
                        el.classList.add("fc-day-redirect");
                    } else {
                        el.classList.add("fc-day-highlited");
                    }
                    el.dataset.serviceTypeRef = getServiceTypeRef(shouldRedirectTo);
                }

                if (isHighlited && !isWaitingListOnly) {
                    el.classList.add("fc-day-highlited");
                }

                // Отключаем даты раньше сегодняшнего дня и после максимальной даты
                if (date < today || date > maxDate) {
                    el.classList.add("fc-day-disabled");
                }
                // Лист ожидания — только если нет слотов у косметологов
                if (isWaitingListDate && hasWaitingList && !isInFreeDates) {
                    el.classList.add("fc-day-waiting-list");
                }

                if (isInFreeDates && !isHighlited && !isRedirectDate) {
                    el.classList.add("fc-day-highlited");
                }
                // Если нет листа ожидания, отключаем даты
                if (
                    !isHighlited
                    && !isRedirectDate
                    && (
                        forceDisableNonHighlightedDates
                        || (!isInFreeDates && !isWaitingListDate)
                    )
                ) {
                    el.classList.remove("fc-day-waiting-list");
                    el.classList.add("fc-day-disabled");
                }
            });
        },
        dateClick: (info) => {
            const date = new Date(info.date);
            const dateStr = formatDateToString(date);
            const isWaitingList = info.dayEl.classList.contains("fc-day-waiting-list")
                && !info.dayEl.classList.contains("fc-day-highlited")
                && !info.dayEl.classList.contains("fc-day-redirect");

            if (date >= today && date <= maxDate && (!info.dayEl.classList.contains("fc-day-disabled"))) {
                calendarEl.querySelectorAll(".fc-daygrid-day").forEach((el) => {
                    el.classList.remove("fc-day-active");
                });

                info.dayEl.classList.add("fc-day-active");

                dateKeeper.value = info.dateStr;
                dateKeeper.dataset.serviceTypeRef = info.dayEl.dataset.serviceTypeRef || "";
                const canPass = onDateClick(dateStr, isWaitingList);

                if (!canPass) return;
                dateKeeper.dispatchEvent(new Event("change"));
            }
        },
    });
    calendar.render();

    return calendar;
}
